export const getLocalUTC = () => {
  const hours = new Date().getTimezoneOffset();
  if (hours > 0) {
    return `-${hours / 60}`;
  } else {
    return `+${(hours * -1) / 60}`;
  }
};
